import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

// Homepage best-sellers strip. Now driven by the per-product
// `is_best_seller` flag (admin-toggleable from the dashboard) rather
// than a hardcoded slug list, flipping the flag on any product surfaces
// it here without a code deploy. Cap per format so the homepage stays
// scannable even if admin has flagged twenty products.
const PER_FORMAT_CAP = 3;

const STRIPS = [
  { key: "pen", label: "Pen kits" },
  { key: "raw", label: "Raw vials" },
];

export default function BestSellers() {
  const { data: products = [] } = useQuery({
    queryKey: ["home-catalog"],
    queryFn: async () => (await api.get("/products")).data,
  });

  const flagged = products.filter((p) => p.is_best_seller);

  // Group flagged products by format up to the cap. Preserving DB order
  // means admin can influence the render order by touching (patch) the
  // products in the intended sequence, without needing an explicit
  // display_order column.
  const byFormat = STRIPS.map((strip) => ({
    ...strip,
    items: flagged.filter((p) => p.format === strip.key).slice(0, PER_FORMAT_CAP),
  }));

  return (
    <section className="border-b border-line" data-testid="best-sellers">
      <div className="container-pd py-16 lg:py-24">
        <p className="label-mono text-brandblue">↳ Launch picks · three formats</p>
        <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Best sellers
        </h2>

        {byFormat.map((strip, idx) =>
          strip.items.length > 0 ? (
            <div
              key={strip.key}
              className={idx === 0 ? "mt-10" : "mt-12"}
              data-testid={`best-sellers-${strip.key}`}
            >
              <p className="label-mono text-navy">{strip.label}</p>
              <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {strip.items.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            </div>
          ) : null
        )}
      </div>
    </section>
  );
}
